export const errMsg = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || String(x)).join('; ') || fallback;
  return fallback;
};
